import { Dayjs } from "dayjs"
import {
  IDebtPaymentPlan,
  DebtPaymentPlanStatus,
} from "./debtPaymentPlan.types"

export class DebtPaymentPlan implements IDebtPaymentPlan {
  constructor(
    public status: DebtPaymentPlanStatus,
    public id: number,
    public planLengthInMonths: number,
    public remainingPaymentMonths: number,
    public createdAt: Dayjs,
    public totalDebt?: number,
    public debtMonthlyPayment?: number,
    public remainingBalance?: number,
    public paymentDay?: number,
    public lastPaymentDate?: Dayjs,
    public type?: string,
  ) {}

  get isActive(): boolean {
    return this.status === DebtPaymentPlanStatus.ACTIVE
  }

  get isDDRA(): boolean {
    return this.type === "EXTERNAL"
  }
}
